<template>
  <lu-vbox class='app-container svpad-in-20' lu-flex>
   <Spinner ref='spinner' />

    <lu-item>
      <PageHeader :title='headTitle' :hasList='true' :hasReload='true' :hasPrev='hasPrev' :hasNext='hasNext' @prev='goPrev' @next='goNext' @back='back' @reload='reload' >
        <lu-hbox slot='extraArea' class='pad-in-5' >
            <template v-if='!isReadOnly'>
              <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('save') }}</el-button></lu-item>
              <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancel'>{{ $t('cancel') }}</el-button></lu-item>
            </template>
            <template v-else-if="isAllowed()">
              <lu-item><el-button class="button" icon="el-icon-edit" v-if='form.statusId === 5' @click.stop='regenerateAccountCode(form.userEmail)' >{{ $t('Regenerate Code') }}</el-button></lu-item>
              <lu-item><el-button class="button" icon="el-icon-edit" @click.stop='edit' >{{ $t('edit') }}</el-button></lu-item>
              <lu-item><el-button class="button" icon="el-icon-delete" v-if="isAllowed() && (form.isUsed === 0 || form.statusId === 1 || form.statusId === 4 || form.statusId === 5)"
              @click.stop='handleDelete([{ userId: form.userId }])' >{{ $t('delete') }}</el-button></lu-item>
            </template>
        </lu-hbox>
      </PageHeader>
    </lu-item>

    <lu-scroll-area lu-flex lu-flex-wrap>
      <el-form ref='form' :model='form' :rules="rules" label-width="180px">


        <lu-vbox lu-flex lu-flex-wrap class='sectionBox'>
          <PageTitle :title='$t("Logo")' :expanded='logoExpanded' @toggleClose='toggleLogoClose' />

          <lu-hbox v-if='logoExpanded'>
            <el-form-item class='mar-l-10' prop='userLogo' style='max-width: 500px;' lu-flex-wrap v-if='!isReadOnly'>
              <el-upload
                ref='uploadLogo'
                  :auto-upload="false"
                  action=""
                  v-model='form.userLogo'
                  list-type="picture-card"
                  :on-preview="handlePreviewLogo"
                  :on-remove="handleRemoveLogo"
                  :on-change="changeLogo"
                  :before-upload="beforeUploadLogo"
                  :disabled='isReadOnly'
                  accept=" .jpg, .jpeg, .png"
                  :limit=1
                  >
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">{{ $t('jpg/png files with a size less than 500kb') }}</div>
                </el-upload>
                <!-- <el-dialog>
                  <img width="50%" src="form.userLogo" alt="">
                </el-dialog> -->

                  <el-dialog :visible.sync="logoVisible">
                    <img width="100%" :src="logoImageUrl" alt="">
                  </el-dialog>
            </el-form-item>

            <lu-item lu-vcenter lu-hcenter v-if='form.userLogo && isReadOnly'>
              <img :src="form.userLogo" style='margin: 0 0 40px 224px;width:148px; height: 148px; border-radius: 5px;'>
            </lu-item>

          </lu-hbox>
        </lu-vbox>


      <lu-vbox lu-vtop lu-flex lu-flex-wrap class='sectionBox'>
        <PageTitle :title='$t("Personal data")' :expanded='persoExpanded' @toggleClose='togglePersonClose' />

        <lu-hbox lu-flex lu-flex-wrap v-if='persoExpanded'>

          <el-form-item auto :label="$t('Login')" prop='login' :required='!isReadOnly'>
            <el-input :disabled="isReadOnly" :placeholder="form.login" type="text" clearable v-model='form.login' />
          </el-form-item>

          <el-form-item auto :label="$t('Is admin')" prop='isAdmin' >
            <lu-item style='width: 300px;'>
              <el-checkbox disabled v-model="form.isAdminBool" style='padding-left: 15px;'/>
            </lu-item>
          </el-form-item>

          <el-form-item auto :label="$t('Password:')"  prop='password' v-if="this.$route.params.create"  >
            <el-input type='password' placeholder="Please input password" v-model="form.password" />
          </el-form-item>

          <el-form-item auto :label="$t('Confirm Password:')"  prop='password2' v-if="this.$route.params.create" >
            <el-input type="password" show-password v-model='form.password2'/>
          </el-form-item>

          <el-form-item auto :label="$t('Status')" prop='statusId' sv-if="isReadOnly"  >
            <lu-item style='width: 300px;'>
              <el-tag style='width:150px;margin-left: 15px;' size="mini" :type='statusActiveClass(form.statusId)'>
                <i :class="statusActiveName(form.statusId)" style='margin-right: 5px;' />
                  {{ form.userStatusLabel }}
              </el-tag>
            </lu-item>
            <!--
            <el-select disabled v-model="form.statusId" filterable clearable>
              <el-option v-for='item in userStatusList' :key="item.id" :label='item.label' :value='item.id'></el-option>
            </el-select>
            -->
          </el-form-item>

          <el-form-item auto :label="$t('Gender')" prop='userGender'>
            <!-- <lu-item style='width: 300px;'>
              <el-radio :disabled='isReadOnly' style='padding-left: 15px;' v-model='form.userGender' v-for='item in optionsGender' :key='item.value' :label='item.value'>{{ item.label }}</el-radio>
            </lu-item> -->

            <el-radio-group v-model="form.userGender">
              <el-radio :disabled='isReadOnly' v-for='item in optionsGender' :key='item.value' :label='item.value'>{{ item.label }}</el-radio>
            </el-radio-group>

          </el-form-item>

          <el-form-item auto :label="$t('First name')"  prop='userFirstName' :required='!isReadOnly'>
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' clearable v-model='form.userFirstName' />
          </el-form-item>

          <el-form-item auto :label="$t('Last name')"  prop='userLastName' :required='!isReadOnly'>
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' type="text" clearable v-model='form.userLastName' />
          </el-form-item>

          <el-form-item auto :label="$t('Date of birth')" prop='birthDate' >
            <el-date-picker :readonly='isReadOnly' id="date" :disabled='isReadOnly'
              v-model="form.birthDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
          </el-form-item>

          <el-form-item auto :label="$t('Role')"  prop='roleId' :required='!isReadOnly'>
            <el-select :disabled='isReadOnly' v-model="form.roleId" filterable clearable>
              <el-option v-for='item in roleList' :key="item.roleId" :label='item.label' :value='item.roleId'></el-option>
            </el-select>
          </el-form-item>
        </lu-hbox>
      </lu-vbox>


      <lu-vbox lu-vtop lu-flex lu-flex-wrap class='sectionBox'>
        <PageTitle :title='$t("Contact data")' :expanded='contactExpanded' @toggleClose='toggleContactClose'  />

        <lu-hbox lu-flex lu-flex-wrap v-if='contactExpanded'>
          <el-form-item  auto :label="$t('Street name')"  prop='addStreet' >
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' type="text" clearable v-model='form.addStreet' />
          </el-form-item>
          <el-form-item  auto :label="$t('Street Number')"  prop='addStreetNum' >
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' type="text" clearable v-model='form.addStreetNum' />
          </el-form-item>

          <el-form-item auto :label="$t('City')" prop='addCity' >
            <el-input :readonly='isReadOnly' :disabled='isReadOnly'  type="text" clearable v-model='form.addCity'/>
          </el-form-item>
          <el-form-item auto :label="$t('Zip code')"  prop='addZipCode' >
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' type="text" clearable v-model='form.addZipCode'/>
          </el-form-item>

          <el-form-item auto :label="$t('Country')"  class='vpad-in-1' prop='codeCountry' >
            <el-select :disabled='isReadOnly' v-model="form.codeCountry" filterable clearable>
              <el-option v-for='item in countryList' :key='item.countryCode' :label='item.label' :value='item.countryCode'></el-option>
            </el-select>
          </el-form-item>

          <el-form-item auto :label="$t('State')"  prop='addState' :required='stateList.length > 0'>
            <el-select :disabled='isReadOnly' v-model="form.addState" filterable clearable>
              <el-option v-for='item in stateList' :key="item.stateCode" :label='item.label' :value='item.stateCode'></el-option>
            </el-select>
          </el-form-item>

          <el-form-item auto :label="$t('Phone number')" prop='phoneNumber' >
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' type="text" clearable v-model='form.phoneNumber' />
          </el-form-item>

          <el-form-item auto :label="$t('Email address')" prop='userEmail'  :required='!isReadOnly' >
            <el-input :readonly='isReadOnly' :disabled='isReadOnly' class="name"  clearable v-model='form.userEmail' type="text" />
          </el-form-item>

        </lu-hbox>
      </lu-vbox>

    </el-form>

    </lu-scroll-area>
  </lu-vbox>
</template>

<script>
import FormController from '@/controllers/FormController'
import { LuHbox, LuVbox, LuScrollArea, LuItem } from 'lusis-ui'
import { mapGetters } from 'vuex'
import PageHeader from '@/components/PageHeader'
import PageTitle from '@/components/PageTitle'
import Spinner from '@/components/Spinner'
import userMixin from './mixin'
import Debouncer from '@/utils/debounce.js'

export default {
  name: 'adminUserEdit',
  extends: FormController,
  mixins: [ userMixin ],
  components: { LuHbox, LuVbox, LuItem, LuScrollArea, Spinner, PageTitle, PageHeader },
  mounted () {
    if (this.$route.params && typeof this.$route.params.create === 'undefined') {
      this.$router.push('/home?next=' + new Date().toJSON())
      return
    }
    if (!this.isAllowed() || (!this.$route.params.create && !this.$route.params.recordId)) {
      this.$router.push('/home?next=' + new Date().toJSON())
      return
    }
    this.$nextTick().then(() => this.autoCompleteOff())
  },
  updated () {
    this.$nextTick().then(() => this.autoCompleteOff())
  },
  data () {
    return {
      debouncer: new Debouncer(),
      message: '',
      logoExpanded: false,
      persoExpanded: true,
      contactExpanded: true,
      isSuccess: false,
      isReadOnly: (!this.$route.params.create) ? this.$route.params.isReadOnly : false,
      logoImageUrl: '',
      logoVisible: false,
      form: {
        birthDate: null,
        password: null,
        password2: null
      },
      editRules: {
        login: [
          { required: true, message: this.$t('Please input an login'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] },
          { validator: this.validateUserLogin, message: this.$t('Login already exists') }
        ],
        userGender: [
          { required: false, message: this.$t('Please select gender'), trigger: ['change'] }
        ],
        userFirstName: [
          { required: true, message: this.$t('Please input first name'), trigger: ['blur', 'change'] }
        ],
        userLastName: [
          { required: true, message: this.$t('Please input last name'), trigger: ['blur', 'change'] }
        ],
        birthDate: [
          { required: false, message: this.$t('Please select date of birth'), trigger: ['blur', 'change'] }
        ],
        addStreet: [
          { required: false, message: this.$t('Please input street name'), trigger: ['blur', 'change'] }
        ],
        addStreetNum: [
          { required: false, message: this.$t('Please input street number'), trigger: ['blur', 'change'] }
        ],
        addCity: [
          { required: false, message: 'Please input city', trigger: ['blur', 'change'] }
        ],
        addZipCode: [
          { required: false, message: 'Please input zip code', trigger: ['blur', 'change'] }
        ],
        codeCountry: [
          { required: false, message: 'Please select country', trigger: 'change' }
        ],
        roleId: [
          { required: true, message: 'Please select role', trigger: 'change' }
        ],
        password: [
          { required: true, message: this.$t('Please input password'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 8 characters.'), trigger: ['blur', 'change'] },
          { validator: this.validatePassword, message: this.$t('Passwords do not match') }
        ],
        password2: [
          { required: true, message: this.$t('Please input confirm password'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 8 characters.'), trigger: ['blur', 'change'] },
          { validator: this.validateConfirmPassword, message: this.$t('Passwords do not match') }
        ],
        phoneNumber: [
          { required: false, message: 'Please select phone number', trigger: ['blur', 'change'] }
        ],
        userTitle: [
          { required: true, message: this.$t('Please input the User title'), trigger: ['blur', 'change'] }
        ],
        userEmail: [
          { required: true, message: 'Please input e-mail address', trigger: ['blur', 'change'] },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] },
          { validator: this.validateCounterEmail, message: this.$t('E-mail already exists'), trigger: ['blur', 'change'] }
        ]
      },
      optionsGender: [{ value: 1, label: 'M' }, { value: 2, label: 'F' }]
    }
  },
  methods: {
    isAllowed () {
      return this.$acl.isAllowed('adminUserEdit', this.isAdmin) || this.userInfos.userId === this.$route.params.recordId
    },
    pageControllerName: function () {
      return 'adminUserEdit'
    },
    autoCompleteOff: function () {
      document.querySelectorAll('input[type=password]').forEach(f => {
        f.autocomplete = 'new-password'
      })
    },
    togglePageTitle: function () {

    },
    toggleLogoClose: function () {
      this.logoExpanded = !this.logoExpanded
    },
    togglePersonClose: function () {
      this.persoExpanded = !this.persoExpanded
    },
    toggleContactClose: function () {
      this.contactExpanded = !this.contactExpanded
    },
    swapTooltip: function () {
      return this.form.statusId === 1 ? this.$t('Turn off') : this.$t('Turn on')
    },
    getRecord: function () {
      this.isReadOnly = true
      return this.fetchRecord('readUser', {
        indDetail: 1,
        conditions: [ { 'field name': 'userId', operator: '=', value: [ this.$route.params.recordId ] } ]
      }, 'userList')
    },
    validator: function () {
      return null
    },
    back: function () {
      this.returnPage()
    },
    edit: function () {
      this.isReadOnly = false
    },
    cancel: function () {
      if (this.$route.params.create) this.returnPage()
      this.isReadOnly = true
      this.$refs.form.resetFields()
      this.reload()
    },
    validatePassword (rule, value, cb) {
      if (this.form.password2 !== '') {
        this.$refs.form.validateField('password2')
      }
      cb()
    },
    validateConfirmPassword (rule, value, cb) {
      if (value === '') {
        cb(new Error('Please input the password again'))
      }
      else if (value !== this.form.password) {
        cb(new Error('Passwords does not match!'))
      }
      else {
        cb()
      }
    },
    createFormData: function () {
      this.debouncer.clear()
      this.initFormField(this.form, 'userId', null)
      this.initFormField(this.form, 'login', '')
      this.initFormField(this.form, 'userFirstName', '')
      this.initFormField(this.form, 'userLastName', '')
      this.initFormField(this.form, 'phoneNumber', '')
      this.initFormField(this.form, 'roleId', null)
      this.initFormField(this.form, 'userEmail', '')
      this.initFormField(this.form, 'statusId', null)
      this.initFormField(this.form, 'addCity', '')
      this.initFormField(this.form, 'addState', '')
      this.initFormField(this.form, 'addStreet', '')
      this.initFormField(this.form, 'addStreetNum', '')
      this.initFormField(this.form, 'addZipCode', '')
      this.initFormField(this.form, 'codeCountry', '')
      this.initFormField(this.form, 'userGender', 1)
      this.initFormField(this.form, 'updateDateTime', '')
      this.initFormField(this.form, 'isAdmin', null)
      this.initFormField(this.form, 'birthDate', '')
      this.initFormField(this.form, 'userLogo', '')
      this.initFormField(this.form, 'userLogoId', null)
      this.initFormField(this.form, 'userLogoChanged', false)

      if (this.form.roleId === 0) this.form.roleId = null
      if (this.form.birthDate === '0000-00-00') this.form.birthDate = '' // pas trop bien
      this.form.isAdminBool = this.form.isAdmin === 1
      this.form.userStatusLabel = this.getLabel(this.userStatusListById, this.form.statusId, 'label')
      this.name = 'User'
    },
    changeLogo (file) {
      if (!this.checkLogo(file)) return false
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = function () {
        self.form.userLogo = this.result
        self.form.userLogoChanged = true
      }
    },
    checkLogo (file) {
      const isExceedLogoSize = file.size / 1024 / 1024 < 0.5 // 500k
      if (!isExceedLogoSize) {
        this.form.userLogo = null
        this.$message.error(this.$t('The file size exceeds the limit allowed 500kb'))
        this.$refs.uploadLogo.clearFiles()
        return false
      }
      return true
    },
    handlePreviewLogo (file) {
      this.logoImageUrl = file.url
      this.logoVisible = true
    },
    handleRemoveLogo () {
      this.$refs.uploadLogo.clearFiles()
      this.form.userLogo = null
    },
    beforeUploadLogo (file) {
      if (!this.checkLogo(file)) return false
    },
    validateUserLogin (rule, value, cb) {
      let cond = [{'field name': 'login', 'operator': '=', 'value': [ value ]}]
      return this.$tango.searchUser({conditions: cond}).then(rep => {
        if (rep.resultCode === 0) {
          if (rep.userList && rep.userList[0].userId === this.form.userId) {
            cb(undefined)
          }
          else {
            cb(!rep.totalCount ? undefined : new Error())
          }
        }
        else cb(new Error())
      })
    },
    validateCounterEmail: function (rule, value, cb) {
      this.debouncer.debounce(500, function () {
        this.checkCounterEmail().then(r => {
          cb(r ? undefined : new Error())
        })
      }.bind(this))
    },
    checkCounterEmail () {
      return this.$tango.getUserInfoByEmail({ 'userEmail': this.form.userEmail }).then(rep => {
        if (rep.userInfos.userId === this.form.userId || rep.resultCode === 8 || rep.userInfos.userEmail !== this.form.userEmail) {
          return true
        }
        throw new Error()
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
        /*
        this.$message({
          type: 'error',
          message: this.resultMessage[11]
        })
        */
      })
    },
    statusActiveClass (type) {
      if (type === 1) return 'success'
      else if (type === 2 || type === 3) return 'primary'
      else if (type === 4 || type === 5) return 'danger'
      return 'warning'
    },
    statusActiveName (type) {
      if (type === 1) return 'el-icon-success'
      else if (type === 4 || type === 5) return 'el-icon-loading'
      else return 'el-icon-check'
    },
    save: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.spinner.show()
          if (!this.form.birthDate) this.form.birthDate = '0000-00-00'
          let api = this.$route.params.create ? 'createAccount' : 'updateUser'
          if (!this.form.userLogoChanged) {
            delete this.form.userLogo
          }
          this.$tango[api](this.form).then(rep => {
            this.$refs.spinner.hide()
            if (rep.resultCode !== 0) throw new Error(rep.resultCode)
            if (this.userInfos.roleId === rep.roleId) {
              this.$acl.setPermissions(rep.userInfos.permissions)
              this.$acl.setPermissionBrokers(rep.userInfos.permissionBrokers)
              this.$store.dispatch('permission/GenerateRoutes', { roles: rep.userInfos.permissions, isAdmin: this.isAdmin })
            }

            let isCreate = this.$route.params.create

            this.$message({
              type: 'success',
              message: isCreate ? this.$t('Creation user has been successfully completed') : this.$t('Modification user has been successfully completed')
            })

            if (rep.userInfos.userId === this.userInfos.userId) {
              this.$store.commit('user/userInfos', Object.assign({ netId: this.userInfos.netId }, rep.userInfos))
              this.$acl.setPermissions(rep.userInfos.permissions)
              this.$acl.setPermissionBrokers(rep.userInfos.permissionBrokers)
            }

            this.$route.params.recordLabel = rep.userInfos.login
            this.$route.params.recordId = this.form.userId = rep.userInfos.userId

            if (this.$route.params.create) {
              this.$store.dispatch('tagsView/addView', this.$route)
            }
            else {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }

            this.isReadOnly = true
            if (isCreate) {
              this.reloadForm(Object.assign({
                recordLabel: rep.userInfos.login,
                recordId: rep.userInfos.userId
              }, rep))
            }
            else {
              this.reload()
            }
            // eslint-disable-next-line handle-callback-err
            //if (this.$route.params.create) this.$router.push({ name: 'adminUserList' }).catch(err => {})
          }).catch(() => {
            this.$message({
              type: 'error',
              message: this.$t('Tango server error')
            })
          })
        }
        else {
          this.$refs.spinner.hide()
        }
      })
    },
    /*
    onActivation: function () {
      if (this.form.statusId === 3) {
        this.form.active = false
        this.tango.activateUser(this, { userUId: this.form.userUId }).then(rep => {
          this.reload()
        }).catch(err => {
          console.log(err)
          this.reload()
        })
      }
      else {
        this.form.active = true
        this.$tango.deactivateUser(this, { userUId: this.form.userUId }).then(rep => {
          this.reload()
        }).catch(err => {
          console.log(err)
          this.reload()
        })
      }
    },
    */
  },
  computed: {
    ...mapGetters([ 'userStatusList', 'isAdmin' ]),
    ...mapGetters([ 'userInfos', 'countryList' ]),
    headTitle: function () {
      let title = this.$t('Create') + ' ' + this.name
      if (!this.$route.params.create) {
        title = ((this.isReadOnly) ? this.name : this.$t('Edit')) + ' : '
        title += this.userName
      }
      return title
    },
    stateList: function () {
      let idx = this.countryList.findIndex(c => c.countryCode === this.form.codeCountry)
      return idx !== -1 ? this.countryList[idx].stateList || [] : []
    },
    param: function () {
      return this.$route.params
    },
    requiredMessage: function () {
      return this.isReadOnly ? null : this.$t('This field is required')
    },
    userName: function () {
      return this.form.userLastName + ' ' + this.form.userFirstName
    },
    rules: function () {
      return this.isReadOnly ? {} : this.editRules
    }
  }
  /*
  watch: {
    'userInfos': {
      handler: function (v) {
        if (!this.$route.params.create && v.login === this.form.login) {
          this.form.lastName = v.lastName
          this.form.firstName = v.firstName
          this.form.fullName = v.fullName
          this.form.emailAddress = v.emailAddress
          this.form.phoneNo = v.phoneNo
        }
      },
      deep: true,
      immediate: true
    }
  },
  */
}
</script>

<style scoped>

</style>